import React from 'react';
import { SkeletonBlock } from './SkeletonBlock';
import { SkeletonText } from './SkeletonText';

interface CardGridSkeletonProps {
  cards?: number;
  className?: string;
}

export const CardGridSkeleton: React.FC<CardGridSkeletonProps> = ({
  cards = 6,
  className = '',
}) => {
  return (
    <div className={`aa-skeleton-grid ${className}`} aria-hidden="true">
      {Array.from({ length: cards }).map((_, index) => (
        <div className="aa-skeleton-card" key={index}>
          <SkeletonBlock height={140} />
          <SkeletonText lines={3} className="mt-3" />
        </div>
      ))}
    </div>
  );
};
